// extracted by mini-css-extract-plugin
module.exports = {"imgUrl":"InfoModal_imgUrl__2guwZ"};